// src/components/orders/MyOrders.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "./MyOrders.css"; 

const MyOrders = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const storedUser = sessionStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const token = sessionStorage.getItem("token");
  const uniqueCode = sessionStorage.getItem("uniqueCode");

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("📦 My Orders");

  useEffect(() => {
    if (user) {
      fetchOrdersByRole(user.role, user.id, uniqueCode);
    }
  }, [user?.id, user?.role, API_URL]);

  // ✅ Fetch orders dynamically by user role
  const fetchOrdersByRole = async (role, id, uniqueCode) => {
    setLoading(true);
    try {
      let endpoint = "";

      switch (role) {
        case "admin":
          endpoint = `${API_URL}/orders`;
          setTitle("📦 All Orders");
          break;

        case "venueProvider":
          endpoint = `${API_URL}/orders/venue-provider/${uniqueCode}`;
          setTitle("🏢 My Venue Bookings");
          break;

        case "vendorProvider":
          endpoint = `${API_URL}/orders/vendor-provider/${uniqueCode}`;
          setTitle("🎉 My Vendor Bookings");
          break;

        default:
          endpoint = `${API_URL}/orders/getorder/${id}`;
          setTitle("🛒 My Orders");
      }

      console.log(`📡 Fetching from: ${endpoint}`);
      const res = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const orderList = res.data;

      // ✅ Fetch user details for each order
      const enrichedOrders = await Promise.all(
        orderList.map(async (order) => {
          try {
            const userRes = await axios.get(`${API_URL}/user/${order.userId}`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            return { ...order, userDetails: userRes.data };
          } catch (userErr) {
            console.warn(`⚠ Failed to fetch user ${order.userId}`, userErr.message);
            return { ...order, userDetails: null };
          }
        })
      );

      setOrders(enrichedOrders);
    } catch (err) {
      console.error("❌ Error fetching orders:", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <div className="container mt-4">
        <h2 className="mb-4">📦 My Orders</h2>
        <p>⚠ Please log in to see your orders or bookings.</p>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-4">{title}</h2>

      {loading && <p>⏳ Loading...</p>}

      {!loading && orders.length > 0 ? (
        <div className="list-group">
          {orders.map((order) => (
            <div key={order._id} className="list-group-item">
              <h5>👤Customer Name: {order.userDetails?.name}</h5>
              <hr />
              <h5>Name of the venue/vendor : {order.venueName || order.vendorName}</h5>
              <hr />
              <p><strong>Amount Paid:</strong> ₹{order.amountPaid}</p>
              <p><strong>Payment Type:</strong> {order.paymentType}</p>
              <p><strong>Status:</strong> {order.status}</p>
              <p><strong>Date:</strong> {new Date(order.createdAt).toLocaleString()}</p>
            </div>
          ))}
        </div>
      ) : (
        !loading && <p>No orders or bookings found.</p>
      )}
    </div>
  );
};

export default MyOrders;
